/**
 * @fileoverview POST handler for the "/data_objects/:type_name/:external_id/object_relationships" endpoint.
 * Creates CO->CO relationship edges from the anchor object in the given direction.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalIdObjectRelationships } from "./constants";
import type {
  PostCustomObjectsTypeNameExternalIdObjectRelationshipsParams,
  PostCustomObjectsTypeNameExternalIdObjectRelationshipsResponse,
} from "./types";

export const postCustomObjectsTypeNameExternalIdObjectRelationships = reactQueryMutationAdapter(
  customObjectsTypeNameExternalIdObjectRelationships,
  ({
    appGroupId,
    typeName,
    externalId,
    direction,
    targetTypeName,
    relKind,
    targetExternalIds,
  }: PostCustomObjectsTypeNameExternalIdObjectRelationshipsParams): Promise<PostCustomObjectsTypeNameExternalIdObjectRelationshipsResponse> => {
    return fetch<PostCustomObjectsTypeNameExternalIdObjectRelationshipsResponse>(
      `/data_objects/${encodeURIComponent(typeName)}/${encodeURIComponent(externalId)}/object_relationships`,
      "POST",
      {
        app_group_id: appGroupId,
        direction,
        target_type_name: targetTypeName,
        rel_kind: relKind,
        target_external_ids: targetExternalIds,
      },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
